import groq from 'groq';

/* WARN: If you change this query, make sure to update MAX_POSSIBLE_SCORES */
export const searchBenefits = groq`
  *[
    _type == $benefitsPageType &&
    !(_id in path("drafts.**"))
  ] | score(
      boost(_id match $searchTerm, 3),
      boost(pt::text(hero) match $searchTerm, 2),
      pt::text(introduction) match $searchTerm,
      benefits[].title match $searchTerm,
      pt::text(benefits[].description[]) match $searchTerm,
      benefits[].statistic match $searchTerm,
    ) {
      _type,
      _score
    }[ _score > 0 ]
`;
